import { platformEnv } from '@/platform/config/env'
import { createHttpClient } from '@/platform/http/client'
import type { CreateRewardDraft, LearnerReward, RewardDraft, RewardPagination, RewardQuery } from '../model/reward'

const client = createHttpClient(platformEnv.courseApiUrl)

export const rewardsApi = {
  async list(query: RewardQuery): Promise<{ items: LearnerReward[]; pagination?: RewardPagination }> {
    const result = await client.request<LearnerReward[]>({ url: '/v1/admin/learner-rewards', params: query })
    return { items: Array.isArray(result.data) ? result.data : [], pagination: result.pagination }
  },
  async create(draft: CreateRewardDraft): Promise<LearnerReward> {
    return (await client.request<LearnerReward>({ url: '/v1/admin/learner-rewards', method: 'POST', data: draft })).data
  },
  async update(userId: number, draft: RewardDraft): Promise<LearnerReward> {
    return (await client.request<LearnerReward>({ url: `/v1/admin/learner-rewards/${userId}`, method: 'PATCH', data: draft })).data
  },
}

